import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  padding-bottom: 12px;\n  width: 100%;\n  margin-top: 36px;\n\n  .select-label {\n    color: #5f5f69;\n  }\n\n  @media (max-width: 768px) {\n    margin: 0 -16px;\n    padding: 12px 16px 12px;\n    width: auto;\n    border-bottom: 1px solid #e1e4ed;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  font-size: 16px;\n  font-weight: normal;\n  color: ",
        ";\n  @media (max-width: 1200px) {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n\n  .ant-select:not(:where(.css-dev-only-do-not-override-i7pvmq).ant-select-customize-input)\n    .ant-select-selector {\n    background-color: transparent;\n    height: 24px;\n    border: none;\n    padding: 0;\n  }\n\n  .ant-select {\n    .ant-select-arrow {\n      inset-inline-end: 0px;\n      top: 60%;\n      @media (max-width: 1200px) {\n        margin-top: -4px;\n        inset-inline-end: -4px;\n        top: 55%;\n      }\n    }\n  }\n\n  .ant-select-selector {\n    .select-label {\n      font-size: 16px;\n      color: ",
        ";\n      text-align: right;\n      @media (max-width: 1200px) {\n        font-size: 12px;\n      }\n    }\n\n    .ant-select-arrow {\n      display: block;\n    }\n\n    .ant-select-selection-item {\n      @media (max-width: 1200px) {\n        padding-inline-end: 14px;\n      }\n    }\n  }\n\n  .img-wrapper {\n    width: 16px;\n\n    img:first-child {\n      display: block;\n      @media (max-width: 1200px) {\n        display: none;\n      }\n    }\n\n    img:last-child {\n      display: none;\n      @media (max-width: 1200px) {\n        display: block;\n      }\n    }\n  }\n\n  body:has(&) {\n    .select-label {\n      .ant-select-item-option {\n        font-size: 12px;\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Select } from "antd";
import styled from "styled-components";
import themeGet from "@styled-system/theme-get";
import Image from "next/image";
const sortOptions = [
    {
        value: "order_cnt",
        label: /*#__PURE__*/ _jsx("div", {
            className: "select-label",
            children: "인기순"
        })
    },
    {
        value: "new",
        label: /*#__PURE__*/ _jsx("div", {
            className: "select-label",
            children: "최신순"
        })
    },
    {
        value: "price",
        label: /*#__PURE__*/ _jsx("div", {
            className: "select-label",
            children: "낮은가격순"
        })
    },
    {
        value: "title",
        label: /*#__PURE__*/ _jsx("div", {
            className: "select-label",
            children: "자료명순"
        })
    }
];
export const BooksResultDesc = (param)=>{
    let { onClickSort , totalCount , query  } = param;
    const { sort  } = query !== null && query !== void 0 ? query : {};
    return /*#__PURE__*/ _jsxs(SearchResultDescWrap, {
        children: [
            /*#__PURE__*/ _jsxs(SearchResultAmount, {
                children: [
                    "검색 결과 ",
                    totalCount,
                    "건"
                ]
            }),
            /*#__PURE__*/ _jsx(SearchSortingBox, {
                children: /*#__PURE__*/ _jsx("div", {
                    className: "sort-select",
                    children: /*#__PURE__*/ _jsx(Select, {
                        onChange: (value)=>onClickSort(value),
                        style: {
                            width: 120
                        },
                        options: sortOptions,
                        value: sort || "order_cnt",
                        suffixIcon: /*#__PURE__*/ _jsxs("div", {
                            className: "img-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx(Image, {
                                    src: "/static/assets/ico-folding.svg",
                                    width: 16,
                                    height: 16,
                                    alt: "icon-w"
                                }),
                                /*#__PURE__*/ _jsx(Image, {
                                    src: "/static/assets/ico-open-m.svg",
                                    width: 16,
                                    height: 16,
                                    alt: "icon-m"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
export const SearchResultDescWrap = styled.div.withConfig({
    componentId: "sc-1482b612-0"
})(_templateObject());
export const SearchResultAmount = styled.div.withConfig({
    componentId: "sc-1482b612-1"
})(_templateObject1(), themeGet("text.2", "#5F5F69"));
export const SearchSortingBox = styled.div.withConfig({
    componentId: "sc-1482b612-2"
})(_templateObject2(), themeGet("text.2", "#5F5F69"));
